import { ITrademarkStatisticsQuery } from "../../models/statistcs-trademark/query";
import { ITrademarkStatistics } from "../../models/trademark-statistics/respons";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import toggleLoading from "../../utils/helpers/xor";
import paramsReducer from "../base/base-reducer";
import { QueryAction } from "../base/base-reducer";
import { IInternalState, trademarkStatisticsLoading } from "./context";

type Action =
  | { type: "LOADING"; payload: { loading: trademarkStatisticsLoading | trademarkStatisticsLoading[] } }
  | { type: "SET_LIST"; payload: { list: ITrademarkStatistics } }
  | QueryAction<ITrademarkStatisticsQuery>;

const reducer = (state: IInternalState, action: Action): IInternalState => {
  switch (action.type) {
    case "LOADING": {
      return {
        ...state,
        loading: toggleLoading(state.loading, action.payload.loading),
      };
    }
    case "SET_LIST": {
      return {
        ...state,
        list: action.payload.list,
      };
    }

    default: {
      return paramsReducer(state, action);
    }
  }
};

export default reducer;
